import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CitiesResponse } from '../models/cities-response.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TypeListService {
    constructor(private http: HttpClient) { }

    getCitiesByPostalCode(postalCode: string, countryCode: string = 'ar'): Observable<CitiesResponse> {
        const baseUrl = environment.server.api.portalpasProxy;
        return this.http.get<CitiesResponse>(`${baseUrl}/policycenter-typelist/api/Locations/cities-by-postal-code?countryCode=${countryCode}&postalCode=${postalCode}`);
    }
}
